<div class="row ml-1 mt-2">
    <div class="container-timer row pt-1 pl-1 pr-1" (click)="realizarAccion(tarea)"
        *ngFor="let tarea of configBarra">
        <a><em data-toggle="tooltip" data-placement="top" [title]="tarea.nombre" class="icon-timer m-0 ml-1 p-1 fa"
            [ngClass]="tarea.icono">
        </em></a>
    </div>
</div>
